import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  message: string;
  type: string;
  templatelist: any[];
  tempname: string;
  ruleSaveOverwrite?: { targetLabel: string; viewingLabel: string };

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
    this.type = data.type;
    this.templatelist = data.templatelist;
    this.ruleSaveOverwrite = data.ruleSaveOverwrite;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onSubmit(templatename): void {
    // Close the dialog, return true
    this.dialogRef.close(templatename);
  }
  async ontemplateChange(eventvalue) {
  this.tempname=eventvalue.value;
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public type: string,
    public templatelist: any,
    public ruleSaveOverwrite?: { targetLabel: string; viewingLabel: string }
  ) {}
}
